module.exports = __webpack_public_path__ + "img/btn-AMP.c39cdbeb.png";